import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CNContactRXSerie } from 'src/app/models/cncontactrxserie';

/**
 * Dialog host for RxSerie2Component. All of the viewer's behaviour lives in that
 * component so the same UI can also be embedded in a page; this class only bridges
 * MatDialog to it.
 */
@Component({
  selector: 'app-rx-serie-2-dialog',
  templateUrl: './rx-serie-2-dialog.component.html',
  styleUrls: ['./rx-serie-2-dialog.component.scss']
})
export class RxSerie2DialogComponent {

  /** RxSerie2Component takes a list; callers open the dialog on a single serie. */
  public series: CNContactRXSerie[] = [];

  constructor(
    private dialogRef: MatDialogRef<RxSerie2DialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data && data.serie) {
      this.series = [data.serie];
    }
  }

  close(): void {
    this.dialogRef.close();
  }
}
